/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { AddOn } from 'src/app/classes/addOn';
import { Dispatch } from 'src/app/classes/dispatch';
import { DispatchDriverSummary } from 'src/app/classes/dispatch-driver-summary';
import { Events } from 'src/app/classes/events';
import { Ramp } from 'src/app/classes/ramp';
import { RemoteParking } from 'src/app/classes/remote-parking';
import { ADDON_TYPES, FORM_TYPES, PICK_DROP_LOCATIONS } from 'src/app/common/constants';
import { Roles } from 'src/app/common/roles';
import { DispatchService } from 'src/app/services/dispatch.service';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { LoggerService } from 'src/app/services/logger.service';
import { NewTaskService } from 'src/app/services/new-task.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Profile } from './../../classes/profile';

@Component({
  standalone: false,
  selector: 'app-new-task',
  templateUrl: './new-task.component.html',
  styleUrls: ['./new-task.component.scss']
})
export class NewTaskComponent implements OnInit {
  parkingForm: FormGroup;
  formTypes: any[] = FORM_TYPES;
  addOnTypes: string[] = ADDON_TYPES;
  locations: any[] = PICK_DROP_LOCATIONS;
  displaySection:string;
  profile: Profile;
  defaultStartTime: string = moment().format('YYYY-MM-DDTHH:mm');
  defaultEndTime: string = moment().add(30,'minutes').format('YYYY-MM-DDTHH:mm');
  ramps: Array<Ramp> = []
  rampPickUpSpots: any[] = [];
  rampDropOffSpots: any[] = [];
  driversForList: Array<DispatchDriverSummary>;
  minFilterDate: string = moment().toISOString();
  @Output() hidePanel: EventEmitter<any> = new EventEmitter();
  isCoordinator = false;

  constructor(
    public fb: FormBuilder,
    public taskService: NewTaskService,
    public profileService: ProfileService,
    private dispatchService: DispatchService,
    private utilsService: UtilitiesService,
    private toastService: ToastService,
    private eventService: EventsService,
    private logger: LoggerService,
    private eventsDeltaService: EventsDeltaService
  ) {
  }

  subscribToEvents(){
    this.eventService.eventData$.subscribe((eventData: Events) => {
      if(eventData){
        this.ramps = this.getRampsForForm(eventData.locationMarkers[0]?.ramp || []);
      }
    });
  }

  onSelectPickupRamp(e: any): void{
    const filterSpots = this.ramps.filter(ramp => ramp.locationName === e.value);
    this.rampPickUpSpots = filterSpots[0].parking_position;
  }

  onSelectDropOffRamp(e: any): void{
    const filterSpots = this.ramps.filter(ramp => ramp.locationName === e.value);
    this.rampDropOffSpots = filterSpots[0].parking_position;
   }

  getRampsForForm(ramps: Ramp[]): Ramp[]{
    if(ramps && ramps.length){
      let filteredRamps = ramps.filter(ramp => ramp.locationName !== 'Ramp A' && ramp.locationName !== 'Ramp B'
        && ramp.locationName !== 'Ramp C' && ramp.locationName !== 'Ramp D' && ramp.locationName !== 'Ramp E' && ramp.locationName !== 'Ramp H');
      return filteredRamps.sort((a, b) => (parseInt(a.locationName.slice(5)) > parseInt(b.locationName.slice(5))) ? 1 : -1);
    }
    return [];
  }

  ngOnInit(): void {
    // this.ramps = this.getRampsForForm();
    this.subscribToEvents();
    this.buildForm();
    this.parkingForm.get('typeOfTask').valueChanges.subscribe(value=>{
      this.displaySection = value;
    })
    this.profileService.getProfileObs().subscribe(profile=>{
      this.profile = profile;
      this.isCoordinator = this.profile.userRoles.includes(Roles.COORDINATOR);
    });
    this.dispatchService.getDispatchData().subscribe((dispatchData: Dispatch) => {
      if(dispatchData){
        this.driversForList = dispatchData.driverSummaryList;
      }
    });

  }

  onSelectValue (event: any): void {
    this.parkingForm.get('assignedTo').patchValue('Unassigned');
  }

  buildForm(): void {
    this.parkingForm = this.fb.group({
      typeOfTask: this.fb.control(''),
      startTime: this.fb.control(''),
      endTime: this.fb.control(''),
      notes: this.fb.control(''),
      assignedTo: this.fb.control(''),
      addOnDetails: this.fb.array([]),
      aircraft: this.fb.control(''),
      pickUpLocation: this.fb.control(''),
      dropoffLocation: this.fb.control(''),
      pickUpRamp: this.fb.control(''),
      pickUpSpot: this.fb.control(''),
      dropOffRamp: this.fb.control(''),
      dropOffSpot: this.fb.control('')
    });
  }

  get addOnDetails(): FormArray {
    return this.parkingForm.get("addOnDetails") as FormArray;
  }

  newAddOnDetails() : FormGroup{
    let newAddOn = new AddOn();
    newAddOn.GUID = this.utilsService.guid();
    return this.fb.group(newAddOn);
  }

  addAddOnDetails(e:any){
    this.addOnDetails.push(this.newAddOnDetails());
    e.stopImmediatePropagation();
  }

  removeAddOnDetails(i:number){
    this.addOnDetails.removeAt(i);
  }

  buildTask():void{
    let payload =null;
    if(!this.validRequest()){
      return;
    }
    if (this.displaySection=='1') {
      payload = this.buildRemoteParkingPayload();
    }else if (this.displaySection=='2') {
      payload = this.buildOtherPayload();
    }
    if(!payload){
      return;
    }
    this.logger.debug(this.parkingForm.value, 'ui');
    this.taskService.buildTask(payload).subscribe((response: HttpResponse<any>) => {
      if(response.status === 201){
        this.toastService.show(`TASK CREATED SUCCESSFULLY`, { classname: 'bg-success text-light', delay: 4000 });
        this.parkingForm.reset({});
        this.eventsDeltaService.getDeltas();
      }else{
        this.logger.error(`${response.status} ${response.statusText}`);
        this.toastService.show(`TASK NOT CREATED: ${response.status} Error Occurred`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });

  }

  buildRemoteParkingPayload(): RemoteParking{
    return {
      "plannedStartTime": this.parkingForm.value.startTime,
      "plannedCompleteTime":  this.checkMidnight(this.parkingForm.value.startTime, this.parkingForm.value.endTime),
      "specialInstructions": this.parkingForm.value.notes || "",
      "assignToDriverIdFromTaskCreate": this.isCoordinator ? this.parkingForm.value.assignedTo : this.profile.adId,
      "taskTypeId": "2",
      "taskTypeName": "Remote Parking",
      "assignedTo": this.isCoordinator ? this.parkingForm.value.assignedTo : this.profile.adId,
      "selfAssigned": this.parkingForm.value.assignedTo === this.profile.adId || !this.isCoordinator ? "true" : "false",
      "assignedBy": this.profile.adId,
      "createdBy": this.profile.adId,
      "state": "",
      "formType": "RemoteParking",
      "taskName": "Remote-"+this.utilsService.guid(),
      "isCoordinator": this.isCoordinator
    }
  }

  makePassengerArrayForPayload(addOnDetails: Array<AddOn>): Array<string>{
    let passengerArray = [];
    addOnDetails.forEach((addOn: AddOn) => {
      passengerArray.push(addOn.passengerName)
    });
    return passengerArray;
  }

  makeGuidArrayForPayload(addOnDetails: Array<AddOn>): Array<string>{
    let guidArray = [];
    addOnDetails.forEach((addOn: AddOn) => {
      guidArray.push(addOn.GUID)
    });
    return guidArray;
  }


  buildOtherPayload():any{
    return  {
      "tailNumber": this.parkingForm.value.aircraft || "",
      "rampName": this.parkingForm.value.pickUpSpot?.substring(0,2) || "",
      "rampName2": this.parkingForm.value.dropOffSpot?.substring(0,2) || "",
      "rampSpot": this.parkingForm.value.pickUpSpot || "",
      "rampSpot2": this.parkingForm.value.dropOffSpot || "",
      "plannedStartTime": this.parkingForm.value.startTime,
      "plannedCompleteTime": this.checkMidnight(this.parkingForm.value.startTime, this.parkingForm.value.endTime),
      "passenger": this.makePassengerArrayForPayload(this.parkingForm.value.addOnDetails),
      "GUID": this.makeGuidArrayForPayload(this.parkingForm.value.addOnDetails),
      "specialInstructions": this.parkingForm.value.notes || "",
      "assignToDriverIdFromTaskCreate": this.isCoordinator ? this.parkingForm.value.assignedTo : this.profile.adId,
      "taskTypeId": "0",
      "taskTypeName": "Other",
      "pickupLocation": this.parkingForm.value.pickUpLocation || "",
      "dropoffLocation": this.parkingForm.value.dropoffLocation || "",
      "lat2": "",
      "lon2": "",
      "lat1": "",
      "lon1": "",
      "assignedTo": this.isCoordinator ? this.parkingForm.value.assignedTo : this.profile.adId,
      "selfAssigned": this.parkingForm.value.assignedTo === this.profile.adId || !this.isCoordinator ? "true" : "false",
      "assignedBy": this.profile.adId,
      "createdBy": this.profile.adId,
      "state": "",
      "formType": "AdHoc",
      "pickupType": this.getPickupDropoffType(this.parkingForm.value.pickUpLocation),
      "dropOffType": this.getPickupDropoffType(this.parkingForm.value.dropoffLocation),
      "taskName": "Other-"+this.utilsService.guid(),
      "addOnDetails": this.parkingForm.value.addOnDetails,
      "isCoordinator": this.isCoordinator
    }
  }

  private validRequest(): boolean{
    if(!this.profile){
      this.toastService.show(`FORM NOT SUBMITTED: Please login to submit the form!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(!moment(this.parkingForm.get('startTime')?.value).isValid()){
      this.toastService.show(`FORM NOT SUBMITTED: START DATE is invalid!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(!moment(this.parkingForm.get('endTime')?.value).isValid()){
      this.toastService.show(`FORM NOT SUBMITTED: END DATE is invalid!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(moment(this.parkingForm.get('endTime')?.value).isBefore(this.parkingForm.get('startTime')?.value)){
      this.toastService.show(`FORM NOT SUBMITTED: END DATE cannot be before START DATE!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(moment(this.parkingForm.get('endTime')?.value).isSame(this.parkingForm.get('startTime')?.value)){
      this.toastService.show(`FORM NOT SUBMITTED: START and END date cannot be the same!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(this.displaySection === '2' && (this.parkingForm.get('dropoffLocation')?.value === "" || this.parkingForm.get('dropoffLocation')?.value === null)){
      this.toastService.show(`FORM NOT SUBMITTED: DropOff Location is required!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(this.parkingForm.get('pickUpLocation')?.value === "Ramp" && (this.parkingForm.get('pickUpSpot')?.value === "" || this.parkingForm.get('pickUpSpot')?.value === null)){
      this.toastService.show(`FORM NOT SUBMITTED: Ramp & Spot are required when pickup location is Ramp!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(this.parkingForm.get('dropoffLocation')?.value === "Ramp" && (this.parkingForm.get('dropOffSpot')?.value === "" || this.parkingForm.get('dropOffSpot')?.value === null)){
      this.toastService.show(`FORM NOT SUBMITTED: Ramp & Spot are required when dropoff location is Ramp!`, { classname: 'bg-danger text-light', delay: 6000 });
      return false;
    }
    if(this.displaySection === '2' && moment(this.parkingForm.get('startTime')?.value).isAfter(moment().add(7, 'hours'))){
      this.toastService.show(`FORM NOT SUBMITTED: Start time can not be +7 hours ahead of current time.`, { classname: 'bg-danger text-light', delay: 6000 });
      return false
    }
    if(this.displaySection === '2' && moment(this.parkingForm.get('startTime')?.value).isBefore(moment().add(-1, 'hours'))){
      this.toastService.show(`FORM NOT SUBMITTED: Start time can not be -1 or more from current time.`, { classname: 'bg-danger text-light', delay: 6000 });
      return false
    }
    if(this.displaySection === '2' && moment(this.parkingForm.get('endTime')?.value).isAfter(moment().add(8, 'hours'))){
      this.toastService.show(`FORM NOT SUBMITTED: End time can not be more than 8 hours from current time.`, { classname: 'bg-danger text-light', delay: 6000 });
      return false
    }
    return true;
  }

  getPickerStartDateTime(e: any){
    this.parkingForm.get('startTime')?.patchValue(e);
  }

  getPickerEndDateTime(e: any){
    this.parkingForm.get('endTime')?.patchValue(e);
  }

  checkMidnight(startDate: string, endDate: string): string{
    if(moment(endDate).isBefore(startDate)){
      const tomorrow = moment(endDate).add(1,'days');
      const time = endDate.substring(endDate.length - 5);
      endDate = tomorrow.toISOString().substring(0,11).concat(time);
    }
    return endDate;
  }

  getPickupDropoffType(loc: string): string{
    switch (loc) {
      case 'ASC':
      case 'Edgewood':
      case 'FTC':
      case 'Terminal':
        return 'building';
      case 'Map':
        return 'map';
      case 'Ramp':
        return 'ramp';
      default:
        return '';
    }
  }

  cancel(): void{
    this.hidePanel.emit('hide');
  }

}
